export const baseURL = 'http://www.schtyg.cn:3930';
export const pathURL='http://www.schtyg.cn:3930'
export const loadURL ='http://www.schtyg.cn:3930/upload'
export const amapKey='5f678aaad69e1bdc7df701c113bf01c7'
export const amapWebKey='12d2b05f8abdb4844ad6a93f12c8c23e'



// WEBPACK FOOTER //
// ./src/config/index.js